<template>
   <div>
      <b-row class="test-card-row">
         <b-col
            cols="12"
            sm="6"
            xl="3"
            class="mb-3"
            :class="{gradient}"
            v-for="(part, index) in testParts"
            :key="part.name"
         >
            <b-card
               class="test-part-card"
               :class="{
                  inactive: active[index] === -1,
                  danger: active[index] === 0,
                  selected: selected === index,
               }"
               @click="cardSelected(index)"
            >
               <h4 class="my-auto">{{ part.name }}</h4>
               <icon-base class="icon" :width="120" :height="120" :viewBox="viewBox(part.icon)">
                  <component :is="part.icon" />
               </icon-base>
            </b-card>
         </b-col>
      </b-row>
   </div>
</template>

<script>
export default {
   props: {
      active: {
         type: Array,
         default: () => [0, 0, 0, 0],
      },
      selected: {
         type: Number,
         default: null,
      },
      gradient: {
         type: Boolean,
         default: true,
      },
   },

   data() {
      return {
         testParts: [
            {
               name: 'Permitted Purpose',
               icon: 'icon-target',
            },
            {
               name: 'Technological in Nature',
               icon: 'icon-science',
            },
            {
               name: 'Elimination of Uncertainty',
               icon: 'icon-uncertain',
            },
            {
               name: 'Process of Experimentation',
               icon: 'icon-experiment',
            },
         ],
      };
   },

   methods: {
      /** Returns an appropriate viewBox for the svg icon */
      viewBox(icon) {
         if (icon === 'icon-target') {
            return '0 0 15 15';
         }
         return '0 0 120 120';
      },

      cardSelected(index) {
         this.$emit('selection', index);
      },
   },
};
</script>

<style lang="scss" scoped>
.test-card-row {
   padding-left: 8px;
   padding-right: 8px;

   > div {
      padding-left: 8px;
      padding-right: 8px;

      .test-part-card {
         height: 100px;
         color: $white;
         cursor: pointer;

         .card-body {
            padding: 1rem;
            display: flex;
            align-items: center;
            gap: 0.75rem;

            h4 {
               flex: 1;
               font-size: 1.25rem;
               margin: 0;
            }

            .icon {
               transition: color 0.2s;
               color: rgba(255, 255, 255, 0.2);
               flex-shrink: 0;
               height: 68px;
               width: 68px;
            }
         }

         &.selected {
            .icon {
               color: $white;
            }
         }

         @media (min-width: map-get($grid-breakpoints, 'sm')) and (max-width: map-get($grid-breakpoints, 'md') - 1px) {
            .card-body .icon {
               height: 48px;
               width: 48px;
            }
         }

         background-color: #2b967c;
         border: 5px solid transparent;

         &.inactive {
            background: $gray-800;
         }

         &.danger {
            background: $danger-soft;
         }

         &.selected {
            border-color: $primary;
         }
      }

      &.gradient {
         @for $i from 0 through 3 {
            &:nth-child(#{$i + 1}) {
               .test-part-card {
                  @include gradient-blue-green(3, $i);

                  &.inactive {
                     background: $gray-800;
                  }
               }
            }
         }

         @media (max-width: map-get($container-max-widths, 'xl')) {
            @for $i from 0 through 3 {
               &:nth-child(#{$i + 1}) {
                  .test-part-card {
                     @include gradient-blue-green(2, $i % 2);
                  }
               }
            }
         }
      }
   }
}
</style>
